import React from "react";
import { PM2Process } from "../types/pm2";

interface ProcessTableProps {
  processes: PM2Process[];
  onRestart: (name: string) => void;
  onStop: (name: string) => void;
  onViewLogs: (name: string) => void;
  isRestarting: boolean;
  isStopping: boolean;
}

export const ProcessTable: React.FC<ProcessTableProps> = ({
  processes,
  onRestart,
  onStop,
  onViewLogs,
  isRestarting,
  isStopping,
}) => (
  <table className="min-w-full divide-y divide-zinc-200">
    <thead className="bg-zinc-50">
      <tr>
        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-500">
          Name
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-500">
          Status
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-500">
          Memory
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-500">
          CPU
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-500">
          Actions
        </th>
      </tr>
    </thead>
    <tbody className="divide-y divide-zinc-200 bg-white">
      {processes.map((process) => (
        <tr key={process.pm_id}>
          <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-zinc-900">
            {process.name}
          </td>
          <td className="whitespace-nowrap px-6 py-4 text-sm">
            <span
              className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${process.pm2_env.status === "online" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}
            >
              {process.pm2_env.status}
            </span>
          </td>
          <td className="whitespace-nowrap px-6 py-4 text-sm text-zinc-500">
            {Math.round(process.monit.memory / 1024 / 1024)}MB
          </td>
          <td className="whitespace-nowrap px-6 py-4 text-sm text-zinc-500">
            {process.monit.cpu}%
          </td>
          <td className="space-x-2 whitespace-nowrap px-6 py-4 text-sm font-medium">
            <button
              onClick={() => onRestart(process.name)}
              disabled={isRestarting}
              className="text-blue-600 hover:text-blue-900 disabled:opacity-50"
            >
              Restart
            </button>
            <button
              onClick={() => onStop(process.name)}
              disabled={isStopping}
              className="text-red-600 hover:text-red-900 disabled:opacity-50"
            >
              Stop
            </button>
            <button
              onClick={() => onViewLogs(process.name)}
              className="text-zinc-600 hover:text-zinc-900"
            >
              Logs
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
